import { Component, input, computed, inject } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { TrackLinkDirective } from '@analytics/events';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ENVIRONMENT_CONFIG } from '@core/config-angular';

import type { BreadcrumbNavItem } from './breadcrumb.model';

@Component({
  selector: 'wl-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: [
    './breadcrumb.component.essent.scss',
    './breadcrumb.component.ed.scss',
  ],
  standalone: true,
  imports: [
    FaIconComponent,
    AutomationIdDirective,
    TrackLinkDirective,
    CommonModule,
    RouterLink,
  ],
})
export class BreadcrumbComponent {
  readonly #config = inject(ENVIRONMENT_CONFIG);

  readonly routes = input<BreadcrumbNavItem[]>([]);
  readonly breadcrumbRoutes = computed(() => this.routes().slice(0, -1));
  readonly currentPage = computed(
    () => this.routes()[this.routes().length - 1]
  );
  readonly lastPage = computed(
    () => this.breadcrumbRoutes()[this.breadcrumbRoutes().length - 1]
  );

  readonly enableEssentRebranding =
    this.#config.styles?.enableEssentRebranding || false;
}
